import { IFeedback, IFeedbackFetch } from 'src/models/IHost';
import {
  AddReviewAction,
  ClearReviewResultAction,
  DeleteReviewAction,
  ResultAddReviewAction,
  ResultDeleteReviewAction,
  ResultUpdateReviewAction,
  ReviewActionEnum,
  UpdateReviewAction
} from './types';

export const ReviewActionCreators = {
  addReview: (data: IFeedback): AddReviewAction => ({
    type: ReviewActionEnum.REQUEST_ADD_REVIEW,
    data
  }),
  resultAddReview: (status: number): ResultAddReviewAction => ({
    type: ReviewActionEnum.RESULT_ADD_REVIEW,
    status
  }),
  updateReview: (currentReview: IFeedbackFetch, id: string | number): UpdateReviewAction => ({
    type: ReviewActionEnum.REQUEST_UPDATE_REVIEW,
    currentReview,
    id
  }),
  resultUpdateReview: (status: number): ResultUpdateReviewAction => ({
    type: ReviewActionEnum.RESULT_UPDATE_REVIEW,
    status
  }),
  deleteReview: (id: number): DeleteReviewAction => ({
    type: ReviewActionEnum.REQUEST_DELETE_REVIEW,
    id
  }),
  resultDeleteReview: (status: number): ResultDeleteReviewAction => ({
    type: ReviewActionEnum.RESULT_DELETE_REVIEW,
    status
  }),
  clearReviewResult: (): ClearReviewResultAction => ({
    type: ReviewActionEnum.CLEAR_REVIEW_RESULT
  })
};
